import { UserModel } from '@admin/modules/users/models/user.model';

export const mapApiResponseToUserModels = (response: any): UserModel => {
    return {
        ...response,
        permissions: response.extraPermissions.length > 0 //TODO: check possible permissions
    };
};
